import { action } from 'typesafe-actions'
import { DashboardTypes, ICourse, IStudyGoal } from './types'

export const PreferencesRequest = () => action(DashboardTypes.PREFERENCES_REQUEST)
export const PreferencesSuccess = (data: IStudyGoal) =>
  action(DashboardTypes.PREFERENCES_SUCCCESS, { data })
export const PreferencesError = (error: any) => action(DashboardTypes.PREFERENCES_FAILURE, error)
export const PreferenceChangeGoal = (payload: { courseId: string; hoursGoal: number }): any =>
  action(DashboardTypes.PREFERENCES_CHANGE_GOAL, payload)
export const changeShowTooltip = (payload: boolean) =>
  action(DashboardTypes.PREFERENCES_SHOW_INFORMATION, payload)
